import { createContext } from "react";

export interface TooltipsContextProps {
  showTooltips: (selector?: string) => void;
  showTooltip: (element: HTMLElement) => void;
  hideTooltip: (element: HTMLElement) => void;
  hideTooltips: () => void;
}

export const TooltipsContext = createContext({} as TooltipsContextProps);
